import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PHONE_COUNTRY_OPTIONS, getPhoneCountryById } from "@/lib/countryDialCodes";
import { formatNationalPhoneInputLive, formatPhoneInputLive } from "@/lib/phoneFormat";
import { cn } from "@/lib/utils";

/**
 * Indicatif pays + numéro local (EU/US/CA…) ou saisie +… pour le reste du monde.
 */
export default function PhoneCountryNationalInput({
  countryId,
  onCountryIdChange,
  value,
  onChange,
  disabled = false,
  className,
  inputClassName,
  selectClassName,
  countryTestId = "phone-country-select",
  inputTestId = "phone-national-input",
}) {
  const country = getPhoneCountryById(countryId);
  const intlOnly = Boolean(country.intlOnly);

  return (
    <div className={cn("flex flex-col gap-2 sm:flex-row sm:items-stretch", className)}>
      <Select
        value={countryId}
        onValueChange={(v) => {
          onCountryIdChange(v);
          onChange("");
        }}
        disabled={disabled}
      >
        <SelectTrigger
          className={cn("h-11 w-full shrink-0 font-mono text-sm sm:w-[220px]", selectClassName)}
          data-testid={countryTestId}
        >
          <SelectValue placeholder="Pays" />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {PHONE_COUNTRY_OPTIONS.map((opt) => (
            <SelectItem key={opt.id} value={opt.id}>
              {opt.intlOnly ? opt.name : `${opt.name} (+${opt.dial})`}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Input
        type="tel"
        inputMode="tel"
        required
        disabled={disabled}
        value={value}
        onChange={(e) => {
          const raw = e.target.value;
          onChange(intlOnly ? formatPhoneInputLive(raw) : formatNationalPhoneInputLive(country, raw));
        }}
        placeholder={
          intlOnly ? "+32 470 12 34 56" : countryId === "FR" ? "06 12 34 56 78" : "Numéro local"
        }
        className={cn("h-11 min-w-0 flex-1 font-mono tabular-nums", inputClassName)}
        autoComplete="tel"
        data-testid={inputTestId}
      />
    </div>
  );
}
